import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';

import { primaryNavItems } from '../config/nav';
import { cn } from '../ui/cn';

const isPathActive = (pathname: string, itemPath: string): boolean => {
  if (itemPath === '/') {
    return pathname === '/';
  }

  return pathname === itemPath || pathname.startsWith(`${itemPath}/`);
};

const BottomNav: React.FC = () => {
  const { pathname } = useLocation();

  return (
    <nav
      role="navigation"
      aria-label="Primary BottomNav"
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-surface/95 px-2 pb-[calc(env(safe-area-inset-bottom)+0.4rem)] pt-2 backdrop-blur md:hidden"
    >
      <ul className="grid grid-cols-5 gap-1">
        {primaryNavItems.map((item) => {
          const active = isPathActive(pathname, item.path);

          return (
            <li key={item.id}>
              <NavLink
                to={item.path}
                end={item.path === '/'}
                aria-current={active ? 'page' : undefined}
                className={cn(
                  'flex min-h-11 flex-col items-center justify-center gap-1 rounded-xl px-1 py-1.5 text-[11px] font-semibold',
                  'text-muted transition hover:bg-surface2 focus-visible:outline-none',
                  'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
                  active &&
                    'bg-surface2 text-text',
                )}
              >
                <span
                  className={cn(
                    'inline-flex h-7 w-7 items-center justify-center rounded-full border border-transparent text-base',
                    active &&
                      'border-primary bg-primary text-primaryFg',
                  )}
                >
                  <item.icon aria-hidden="true" />
                </span>
                <span>{item.label}</span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default BottomNav;
